<template>
    <div class="ui-alert" :class="`ui-alert--${variant}`" role="alert">
        <div v-if="$slots.icon" class="ui-alert__icon">
            <slot name="icon"></slot>
        </div>

        <div class="ui-alert__body">
            <div v-if="$slots.title" class="ui-alert__title">
                <slot name="title"></slot>
            </div>

            <div class="ui-alert__content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
type Variant = 'info' | 'success' | 'warning' | 'danger';

withDefaults(defineProps<{ variant?: Variant }>(), { variant: 'info' });
</script>
